export default {
  alliant: {
    name: 'Alliant Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Alliant-Credit-Union.zip',
  },
  ally: {
    name: 'Ally Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Ally-Bank.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/American-Express.zip',
  },
  autoowners: {
    name: 'Auto Owners Insurance',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Auto-Owners-Insurance.zip',
  },
  bofa: {
    name: 'Bank of America',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Bank-of-America.zip',
  },
  bestegg: {
    name: 'Best Egg',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Best-Egg.zip',
  },
  bilt: {
    name: 'Bilt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Bilt.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Capital-One.zip',
  },
  chase: {
    name: 'Chase',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Chase.zip',
  },
  citi: {
    name: 'Citibank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Citibank.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Discover.zip',
  },
  fidelity: {
    name: 'Fidelity Investments',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Fidelity-Investments.zip',
  },
  flagstar: {
    name: 'Flagstar Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Flagstar-Bank.zip',
  },
  interactivebrokers: {
    name: 'Interactive Brokers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Interactive-Brokers.zip',
  },
  lemonade: {
    name: 'Lemonade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Lemonade.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/LightStream.zip',
  },
  navyfederal: {
    name: 'Navy Federal Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Navy-Federal-Credit-Union.zip',
  },
  networkcapital: {
    name: 'Network Capital',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Network-Capital.zip',
  },
  pnc: {
    name: 'PNC Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/PNC-Bank.zip',
  },
  rocket: {
    name: 'Rocket Mortgage',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Rocket-Mortgage.zip',
  },
  schwab: {
    name: 'Schwab Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Schwab-Bank.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/SoFi.zip',
  },
  travelers: {
    name: 'Travelers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Travelers.zip',
  },
  ufbdirect: {
    name: 'UFB Direct',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/UFB-Direct.zip',
  },
  unitedexplorer: {
    name: 'United Explorer',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/United-Explorer.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Upgrade.zip',
  },
  upstart: {
    name: 'Upstart',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Upstart.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/US-Bank.zip',
  },
  vanguard: {
    name: 'Vanguard',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Vanguard.zip',
  },
  viobank: {
    name: 'Vio Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Vio-Bank.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Wealthfront.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Wells-Fargo.zip',
  },
  zoefinancial: {
    name: 'Zoe Financial',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/2024-awards-partners/badges/Zoe-Financial.zip',
  },
};
